/**
 * LFM Product Hero — JS
 * Galería custom + ATC integrado con cart-drawer de Dawn
 */

document.addEventListener('DOMContentLoaded', () => {

  const root = document.querySelector('[data-lfm-pdp]');
  if (!root) return;

  // ─── GALERÍA ────────────────────────────────────────────────────────────────

  const slides = [...root.querySelectorAll('[data-lfm-slide]')];
  const thumbs = [...root.querySelectorAll('[data-lfm-thumb]')];
  const prev   = root.querySelector('[data-lfm-prev]');
  const next   = root.querySelector('[data-lfm-next]');

  function setActive(id) {
    slides.forEach(s => s.classList.toggle('is-active', s.dataset.mediaId === id));
    thumbs.forEach(t => t.classList.toggle('is-active', t.dataset.mediaId === id));
  }

  function activeIndex() {
    return slides.findIndex(s => s.classList.contains('is-active'));
  }

  thumbs.forEach(t => t.addEventListener('click', () => setActive(t.dataset.mediaId)));

  prev?.addEventListener('click', () => {
    const i = (activeIndex() - 1 + slides.length) % slides.length;
    setActive(slides[i].dataset.mediaId);
  });

  next?.addEventListener('click', () => {
    const i = (activeIndex() + 1) % slides.length;
    setActive(slides[i].dataset.mediaId);
  });

  // ─── AGREGAR AL CARRITO ──────────────────────────────────────────────────────

  const form   = root.querySelector('[data-lfm-form]');
  const btn    = root.querySelector('.lfm-atc');
  const drawer = document.querySelector('cart-drawer');

  if (!form || !btn) return;

  form.addEventListener('submit', async (e) => {
    e.preventDefault();

    const variantId = form.querySelector('input[name="id"]')?.value;
    if (!variantId) return;

    btn.disabled = true;
    btn.textContent = 'Agregando...';

    // 1. Agrega al carrito
    const addRes = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    });

    if (!addRes.ok) {
      btn.textContent = 'Error, intenta de nuevo';
      setTimeout(() => {
        btn.textContent = form.dataset.atcText || 'Agregar al carrito';
        btn.disabled = false;
      }, 2000);
      return;
    }

    // 2. Espera a que Shopify procese el add
    await new Promise(resolve => setTimeout(resolve, 300));

    // 3. Refresca el drawer con el carrito actualizado
    if (drawer) {
      const res  = await fetch('/?section_id=cart-drawer');
      const html = await res.text();
      const doc  = new DOMParser().parseFromString(html, 'text/html');
      const newContent = doc.querySelector('#shopify-section-cart-drawer');
      const oldContent = document.querySelector('#shopify-section-cart-drawer');
      if (newContent && oldContent) {
        oldContent.innerHTML = newContent.innerHTML;
      }
      drawer.open(btn);
    }

    // 4. Actualiza contador del header
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        document.querySelectorAll('.cart-count-bubble span').forEach(el => {
          el.textContent = cart.item_count;
        });
        document.querySelectorAll('#cart-icon-bubble').forEach(el => {
          el.classList.toggle('hidden', cart.item_count === 0);
        });
      });

    // 5. Restaura botón
    btn.textContent = '✓ Agregado';
    setTimeout(() => {
      btn.textContent = form.dataset.atcText || 'Agregar al carrito';
      btn.disabled = false;
    }, 1800);

  });

});